import { gql } from "@apollo/client";

export const GET_PROJECTS_ALL_TECH = gql`
    query ($start: Int = 0) {
        projects: ProjectSimplifiedCollection(start: $start) {
            id
            title
            description
            link
            priority
            upper_color
            lower_color
            showcase {
                url
            }
            stack {
                id
                name
                type
                icon {
                    url
                }
            }
        }
        technologies: TechnologySimplifiedCollection {
            id
            name
            type
            icon {
                url
            }
        }
    }
`;

export const CREATE_MESSAGE = gql`
    mutation createMessage($name: String!, $email: String!, $message: String!) {
        createMessage(data: { name: $name, email: $email, message: $message }) {
            data {
                attributes {
                    name
                    email
                    message
                }
            }
        }
    }
`;

export const GET_COUNT = gql`
    query {
        meta: BlogSimplifiedCollection {
            total
        }
    }
`;

export const GET_BLOGS = gql`
    query ($start: Int, $limit: Int) {
        blogsResponse: BlogSimplifiedCollection(start: $start, limit: $limit) {
            highlighted {
                id
                title
                slug
                excerpt
                created_at_formatted
                categories {
                    name
                    color
                    bgColor
                }
                cover {
                    url
                }
            }
            blogs {
                id
                title
                slug
                excerpt
                created_at_formatted
                categories {
                    name
                    color
                    bgColor
                }
                cover {
                    url
                }
            }
            total
        }
    }
`;

export const GET_SINGLE_BLOG = gql`
    query ($slug: String) {
        blog: BlogSimplified(filters: { slug: { eq: $slug } }) {
            id
            title
            body
            minutes
            createdAt
            created_at_formatted
            slug
            cover {
                url
            }
            categories {
                name
                color
                bgColor
            }
            related {
                title
                slug
                excerpt
                cover {
                    url
                }
            }
        }
    }
`;

export const GET_SLUGS = gql`
    query {
        blogs(pagination: { limit: 10000 }) {
            data {
                attributes {
                    slug
                }
            }
        }
    }
`;
